import { useApi } from "@utils/useApi";
import { RecurringServicesContractsClient } from "@lib/ShiOneClient";
import { useQuery } from "@tanstack/react-query";
import {
  CACHE_KEY_RECURRING_SERVICES_CONTRACT_DETAIL_BY_CONTRACT_ID
} from "@features/services-feature/contracts/constants";
import type { RecurringServicesContractDetailDto } from "shared-ui/src/features/contracts-feature/canonical";
import { mapRecurringServicesContractDetail } from "./toCanonical/recurringServicesDetailMappers";

export default function useGetRecurringServicesContractDetailByContractId(contractId: number) {
  const api = useApi(RecurringServicesContractsClient);

  const getRecurringServicesContractDetail = async (): Promise<RecurringServicesContractDetailDto | null> => {
    if (!contractId || contractId <= 0) return null;
    const result = await api.getContractDetail(contractId);
    return mapRecurringServicesContractDetail(result);
  };

  return useQuery<RecurringServicesContractDetailDto | null, Error>({
    queryKey: [CACHE_KEY_RECURRING_SERVICES_CONTRACT_DETAIL_BY_CONTRACT_ID, contractId],
    queryFn: getRecurringServicesContractDetail,
    enabled: contractId > 0,
  });
}
